document.querySelectorAll('.globe-faq__item').forEach((detail) => {
  const summary = detail.querySelector('.globe-faq__question');
  const content = detail.querySelector('.globe-faq__answer-wrap');

  if (!summary || !content) return;

  summary.addEventListener('click', (e) => {
    e.preventDefault();

    if (detail.open) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
        content.style.opacity = '0';
      });

      setTimeout(() => {
        detail.open = false;
        content.style.height = '';
      }, 400);

    } else {
      detail.open = true;

      content.style.height = '0px';
      content.style.opacity = '0';

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = '1';
      });

      setTimeout(() => {
        content.style.height = 'auto';
      }, 400);
    }
  });
});